module.exports = __webpack_public_path__ + "static/media/EPS.b4254875.png";